import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@hiring-intelligence/ui';
import CandidatePortalPage from '@/pages/CandidatePortal/CandidatePortalPage';
import CandidateLoginPage from '@/pages/CandidatePortal/CandidateLoginPage';
import CandidateDashboardPage from '@/pages/CandidatePortal/CandidateDashboardPage';
import HiringManagerPortalPage from '@/pages/HiringManagerPortal/HiringManagerPortalPage';

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				{/* Legacy per-link candidate portal */}
				<Route path="/c/:token" element={<CandidatePortalPage />} />

				{/* New identity-match candidate portal */}
				<Route path="/portal/login" element={<CandidateLoginPage />} />
				<Route path="/portal/dashboard" element={<CandidateDashboardPage />} />

				{/* Hiring Manager portal */}
				<Route path="/hm/:token" element={<HiringManagerPortalPage />} />

				<Route path="*" element={<Navigate to="/portal/login" replace />} />
			</Routes>
			<Toaster />
		</BrowserRouter>
	);
}
